import React from "react";
import { useTranslation } from "react-i18next";

//MUI Core Components
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";

type SidebarInfoBoxPOIObjektiProps = {
  link: string
}



const SidebarInfoBoxPOIObjekti = (props: SidebarInfoBoxPOIObjektiProps) => {
  const { t } = useTranslation();

  const { link } = props;

  const default_link = 'https://www.hps.hr/';

  const url = link ? link : default_link;

  return (
    <Box m={2} p={0} pb={2}>
      <Box p={0} width={"100%"} display={"flex"} flex={"row"}>
        <Typography variant="caption" color="#444" paragraph>
          {t("public.info_poi_warning_1")}
          <Link href={url} underline="hover" target="_blank">
            {t("public.info_poi_warning_link")}
          </Link>
        </Typography>
      </Box>        
    </Box>
  )
}

export default SidebarInfoBoxPOIObjekti;